export class RetryError extends Error {
  constructor(message: string, cause: unknown) {
    super(message, { cause });
    this.name = this.constructor.name;

    Object.setPrototypeOf(this, new.target.prototype);
  }

  static isInstance(error: unknown): boolean {
    return error instanceof RetryError;
  }
}
